<template>
    <el-row :gutter="20" class="main_block">
        <div class="mianContent">
            <div class="tagView">
                <div class="title_aside"></div>
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item>{{
                        $route.meta.title
                    }}</el-breadcrumb-item>
                </el-breadcrumb>
            </div>

            <div class="tableBox">
                <el-tabs v-model="activeName" @tab-click="handleClick">
                    <el-tab-pane label="已支付" name="first">
                        <div class="searchBar">
                            <el-form
                                :model="searchParam1"
                                status-icon
                                ref="searchData1"
                                label-position="left"
                                label-width="90px"
                                :inline="true"
                            >
                                <el-form-item label="">
                                    <el-date-picker
                                        @change="datetime"
                                        v-model="dataVal1"
                                        type="datetimerange"
                                        align="right"
                                        start-placeholder="订单创建开始时间"
                                        end-placeholder="订单创建结束时间"
                                        format="yyyy-MM-dd"
                                        value-format="timestamp"
                                        :default-time="['00:00:00', '23:59:59']"
                                    >
                                    </el-date-picker>
                                </el-form-item>
                                <el-form-item label="">
                                    <el-input
                                        type="text"
                                        v-model="searchParam1.id"
                                        autocomplete="off"
                                        placeholder="请输入订单号"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item label="">
                                    <el-button
                                        type="primary"
                                        @click="selectTable('first')"
                                        >查询</el-button
                                    >
                                    <el-button
                                        type="info"
                                        @click="
                                            (searchParam1 = {page: 1,size: 10,status:1,orderBy:'createdAt',sort:'desc'},pageSizeNum1=10,dataVal1=''),
                                            selectTable('first')
                                        "
                                        >重置</el-button
                                    >
                                </el-form-item>
                            </el-form>
                        </div>    
                        <ExTable
                            :table-list="tableData1"
                            :header="header1"
                            :isIndex="false"
                            height="300"
                            :total="total1"
                            :tableId="1"
                            :activeIndex="searchParam1.page"
                            :pageSizeNum="pageSizeNum1"
                            @clickPage="clickPage"
                            @clickSize="clickSize"
                        >
                            <el-table-column slot="operate" label="操作" align="center" width="130">
                                <template slot-scope="scope">
                                    <el-tooltip class="item" effect="dark" 
                                    content="开发票" placement="top">
                                        <i :class="(scope.row.invoiceStatus==2 || scope.row.status==3)?'el-icon-ali-fapiao1 icon-btn icon-btn-disable':'el-icon-ali-fapiao1 icon-btn'" @click="apply(scope.row)"></i>
                                    </el-tooltip>
                                    <el-tooltip class="item" effect="dark" 
                                    content="下载报告" placement="top">
                                        <i class="el-icon-download icon-btn" @click="downloadReport(scope.row)"></i>
                                    </el-tooltip>
                                </template>
                            </el-table-column>
                        </ExTable>
                    </el-tab-pane>
                    <el-tab-pane label="待支付" name="second">
                        <div class="searchBar">
                            <el-form
                                :model="searchParam2"
                                status-icon
                                ref="searchData2"
                                label-position="left"
                                label-width="90px"
                                :inline="true"
                            >
                                <el-form-item label="">
                                    <el-date-picker
                                        @change="datetime"
                                        v-model="dataVal2"
                                        type="datetimerange"
                                        align="right"
                                        start-placeholder="订单创建开始时间"
                                        end-placeholder="订单创建结束时间"
                                        format="yyyy-MM-dd"
                                        value-format="timestamp"
                                        :default-time="['00:00:00', '23:59:59']"
                                    >
                                    </el-date-picker>
                                </el-form-item>
                                <el-form-item label="">
                                    <el-input
                                        type="text"
                                        v-model="searchParam2.id"
                                        autocomplete="off"
                                        placeholder="请输入订单号"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item label="">
                                    <el-button
                                        type="primary"
                                        @click="selectTable('second')"
                                        >查询</el-button
                                    >
                                    <el-button
                                        type="info"
                                        @click="
                                            (searchParam2 = {page: 1,size: 10,status:0,orderBy:'createdAt',sort:'desc'},pageSizeNum2=10,dataVal2=''),
                                            selectTable('second')
                                        "
                                        >重置</el-button
                                    >
                                </el-form-item>
                            </el-form>
                        </div>
                        <p style="color:red;font-size:14px;margin-bottom:20px">*待支付订单1小时内有效，请尽快付款</p>    
                        <ExTable
                            :table-list="tableData2"
                            :header="header2"
                            :isIndex="false"
                            height="300"
                            :total="total2"
                            :tableId="1"
                            :activeIndex="searchParam2.page"
                            :pageSizeNum="pageSizeNum2"
                            @clickPage="clickPage"
                            @clickSize="clickSize"
                        >
                            <el-table-column slot="operate" label="操作" align="center" width="120">
                                <template slot-scope="scope">
                                    <el-tooltip class="item" effect="dark" content="继续支付" placement="top">
                                        <i class="el-icon-ali-jine icon-btn" @click="goPayOredr(scope.row)"></i>
                                    </el-tooltip>
                                    <el-tooltip class="item" effect="dark" content="取消订单" placement="top">
                                        <i class="el-icon-ali-quxiaodingdan icon-btn" @click="cancelOrder(scope.row)"></i>
                                    </el-tooltip>
                                </template>
                            </el-table-column>
                        </ExTable>
                    </el-tab-pane>
                    <el-tab-pane label="已取消" name="third">
                        <div class="searchBar">
                            <el-form
                                :model="searchParam3"
                                status-icon
                                ref="searchData3"
                                label-position="left"
                                label-width="90px"
                                :inline="true"
                            >
                                <el-form-item label="">
                                    <el-date-picker
                                        @change="datetime"
                                        v-model="dataVal3"
                                        type="datetimerange"
                                        align="right"
                                        start-placeholder="订单创建开始时间"
                                        end-placeholder="订单创建结束时间"
                                        format="yyyy-MM-dd"
                                        value-format="timestamp"
                                        :default-time="['00:00:00', '23:59:59']"
                                    >
                                    </el-date-picker>
                                </el-form-item>
                                <el-form-item label="">
                                    <el-input
                                        type="text"
                                        v-model="searchParam3.id"
                                        autocomplete="off"
                                        placeholder="请输入订单号"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item label="">
                                    <el-button
                                        type="primary"
                                        @click="selectTable('third')"
                                        >查询</el-button
                                    >
                                    <el-button
                                        type="info"
                                        @click="
                                            (searchParam3 = {page: 1,size: 10,status:2,orderBy:'createdAt',sort:'desc'},pageSizeNum3=10,dataVal3=''),
                                            selectTable('third')
                                        "
                                        >重置</el-button
                                    >
                                </el-form-item>
                            </el-form>
                        </div>    
                        <ExTable
                            :table-list="tableData3"
                            :header="header3"
                            :isIndex="false"
                            height="300"
                            :total="total3"
                            :tableId="1"
                            :activeIndex="searchParam3.page"
                            :pageSizeNum="pageSizeNum3"
                            @clickPage="clickPage"
                            @clickSize="clickSize"
                        />                
                    </el-tab-pane>
                    <el-tab-pane label="已退款" name="four">
                        <div class="searchBar">
                            <el-form
                                :model="searchParam4"
                                status-icon
                                ref="searchData4"
                                label-position="left"
                                label-width="90px"
                                :inline="true"
                            >
                                <el-form-item label="">
                                    <el-date-picker
                                        @change="datetime"
                                        v-model="dataVal4"
                                        type="datetimerange"
                                        align="right"
                                        start-placeholder="订单创建开始时间"
                                        end-placeholder="订单创建结束时间"
                                        format="yyyy-MM-dd"
                                        value-format="timestamp"
                                        :default-time="['00:00:00', '23:59:59']"
                                    >
                                    </el-date-picker>
                                </el-form-item>
                                <el-form-item label="">
                                    <el-input
                                        type="text"
                                        v-model="searchParam4.id"
                                        autocomplete="off"
                                        placeholder="请输入订单号"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item label="">
                                    <el-button
                                        type="primary"
                                        @click="selectTable('four')"
                                        >查询</el-button
                                    >
                                    <el-button
                                        type="info"
                                        @click="
                                            (searchParam4 = {page: 1,size: 10,status:3,orderBy:'createdAt',sort:'desc'},pageSizeNum4=10,dataVal4=''),
                                            selectTable('four')
                                        "
                                        >重置</el-button
                                    >
                                </el-form-item>
                            </el-form>
                        </div>    
                        <ExTable
                            :table-list="tableData4"
                            :header="header4"
                            :isIndex="false"
                            height="300"
                            :total="total4"
                            :tableId="1"
                            :activeIndex="searchParam4.page"
                            :pageSizeNum="pageSizeNum4"
                            @clickPage="clickPage"
                            @clickSize="clickSize"
                        />                
                    </el-tab-pane>
                </el-tabs>
            </div>
        </div>
    </el-row>
</template>
<script>
import ExTable from "@com/ExTable";
import { searchVerifyOrders,orderCancel,downloadPdfReport} from "@http/overview/index";
import { formatDate, filterParams } from "@/utils/filter";

export default {
    name: "orderVerify",
    data() {
        return {
            activeName:'first',
            pageSizeNum1:10,
            pageSizeNum2:10,
            pageSizeNum3:10,
            pageSizeNum4:10,
            dataVal1:'',
            dataVal2:'',
            dataVal3:'',
            dataVal4:'',
            searchParam1: {
                page: 1,
                size: 10,
                status:1,
                startCreatedAt: "",
                endCreatedAt: "",
                id: "",
                orderBy:'createdAt',
                sort:'desc'
            },
            tableData1: [],
            header1: [
                { minWidth:95, prop: "id", label: "订单号" },
                {
                    prop: "createdAt",
                    minWidth:90,
                    label: "创建时间",
                    formatter: (row) => {
                        return formatDate(row.createdAt);
                    },
                },
                {
                    prop: "pdfName",
                    minWidth:90,
                    label: "验证文件名称",
                },
                {
                    minWidth:70,
                    prop: "payAmount",
                    label: "实付金额",
                    formatter: (row) => {
                        return row.payAmount+'元'
                    },
                },
                {
                    width:100,
                    prop: "payType",
                    label: "支付方式",
                    formatter: (row) => {
                        if(row.payType==1){
                            return "支付宝"
                        }else{
                            return "微信"
                        }
                    },
                },
                {
                    minWidth:90,
                    prop: "paymentAt",
                    label: "支付时间",
                    formatter: (row) => {
                        if(row.paymentAt){
                            return formatDate(row.paymentAt);
                        }
                    },
                },
                {
                    width:120,
                    prop: "invoiceStatus",
                    label: "开票状态",
                    formatter: (row) => {
                        if(row.invoiceStatus==2){
                            return "已开票"
                        }else if(row.status==1){
                            return "未开票"
                        }else{
                            return "不可开票"
                        }
                    },
                },
                // {
                //     width:120,
                //     prop: "status",
                //     label: "订单状态",
                //     formatter: (row) => {
                //         if(row.status==3){
                //             return "已退款"
                //         }else if(row.status==1){
                //             return "已支付"
                //         }else{
                //             return "--"
                //         }
                //     },
                // },
                {
                    minWidth:50,
                    slot: 'operate'
                }
            ],
            total1: 10,
            
            searchParam2: {
                page: 1,
                size: 10,
                status:0,
                startCreatedAt: "",
                endCreatedAt: "",
                id: "",
                orderBy:'createdAt',
                sort:'desc'
            },
            tableData2: [],
            header2: [
                { minWidth:95, prop: "id", label: "订单号" },
                {
                    prop: "createdAt",
                    minWidth:90,
                    label: "创建时间",
                    formatter: (row) => {
                        return formatDate(row.createdAt);
                    },
                },
                {
                    prop: "pdfName",
                    minWidth:90,
                    label: "验证文件名称",
                },
                {
                    minWidth:70,
                    prop: "payAmount",
                    label: "应付金额",
                    formatter: (row) => {
                        return row.payAmount+'元'
                    },
                },
                {
                    width:100,
                    prop: "payType",
                    label: "支付方式",
                    formatter: (row) => {
                        if(row.payType==1){
                            return "支付宝"
                        }else{
                            return "微信"
                        }
                    },
                },
                {
                    minWidth:90,
                    prop: "expiredAt",
                    label: "过期时间",
                    formatter: (row) => {
                        if(row.expiredAt){
                            return formatDate(row.expiredAt);
                        }
                    },
                },
                {
                    minWidth:50,
                    slot: 'operate'
                }
            ],
            total2: 10,
            
            searchParam3: {
                page: 1,
                size: 10,
                status:2,
                startCreatedAt: "",
                endCreatedAt: "",
                id: "",
                orderBy:'createdAt',
                sort:'desc'
            },
            tableData3: [],
            header3: [
                { minWidth:95, prop: "id", label: "订单号" },
                {
                    prop: "createdAt",
                    minWidth:90,
                    label: "创建时间",
                    formatter: (row) => {
                        return formatDate(row.createdAt);
                    },
                },
                {
                    prop: "pdfName",
                    minWidth:90,
                    label: "验证文件名称",
                },
                {
                    minWidth:70,
                    prop: "payAmount",
                    label: "应付金额",
                    formatter: (row) => {
                        return row.payAmount+'元'
                    },
                },
                {
                    minWidth:90,
                    prop: "updatedAt",
                    label: "取消时间",
                    formatter: (row) => {
                        if(row.updatedAt){
                            return formatDate(row.updatedAt);
                        }
                    },
                },
            ],
            total3: 10,

            searchParam4: {
                page: 1,
                size: 10,
                status:3,
                startCreatedAt: "",
                endCreatedAt: "",
                id: "",
                orderBy:'createdAt',
                sort:'desc'
            },
            tableData4: [],
            header4: [
                { minWidth:95, prop: "id", label: "订单号" },
                {
                    prop: "createdAt",
                    minWidth:90,
                    label: "创建时间",
                    formatter: (row) => {
                        return formatDate(row.createdAt);
                    },
                },
                {
                    prop: "pdfName",
                    minWidth:90,
                    label: "验证文件名称",
                },
                {
                    minWidth:70,
                    prop: "payAmount",
                    label: "实付金额",
                    formatter: (row) => {
                        return row.payAmount+'元'
                    },
                },
                {
                    width:100,
                    prop: "payType",
                    label: "支付方式",
                    formatter: (row) => {
                        if(row.payType==1){
                            return "支付宝"
                        }else{
                            return "微信"
                        }
                    },
                },
                {
                    minWidth:70,
                    prop: "refundAmount",
                    label: "退款金额",
                    formatter: (row) => {
                        return row.refundAmount+'元'
                    },
                },
                {
                    minWidth:90,
                    prop: "operateAt",
                    label: "退款时间",
                    formatter: (row) => {
                        if(row.operateAt){
                            return formatDate(row.operateAt);
                        }
                    },
                },
            ],
            total4: 10,
        };
    },
    components: {
        ExTable,
    },
    computed: {
        channelCodeValue(){
            return this.$store.state.config.channelCodeValue;
        },
    },
    mounted() {
    },
    async created() {
        let name=this.$route.query.activeName;
        this.activeName=name ? name :'first';
        let res=await this.getTableData(filterParams(this.searchParam1));
        this.tableData1 =res.data;
        this.total1=res.total;
    },
    methods: {
        async getTableData(data) {
            let res = await searchVerifyOrders(data);
            return res;
        },
        async selectTable(name) {
            let res;
            var re = /^[0-9]+.?[0-9]*/;//判断字符串是否为数字//判断正整数/[1−9]+[0−9]∗]∗/ 
            if(name=='first'){
                if(this.searchParam1.id &&!re.test(this.searchParam1.id)){
                    this.$msg("订单号输入内容格式不正确，请仔细核对");
                    return false;
                }
                this.searchParam1.page=1;
                res=await this.getTableData(filterParams(this.searchParam1));
                this.tableData1=res.data;
                this.total1=res.total;
            }else if(name=='second'){
                if(this.searchParam2.id && !re.test(this.searchParam2.id)){
                    this.$msg("订单号输入内容格式不正确，请仔细核对");
                    return false;
                }
                this.searchParam2.page=1;
                console.log(this.searchParam2)
                res=await this.getTableData(filterParams(this.searchParam2));
                this.tableData2=res.data;
                this.total2=res.total;
            }else if(name=='third'){
                if(this.searchParam3.id && !re.test(this.searchParam3.id)){
                    this.$msg("订单号输入内容格式不正确，请仔细核对");id
                    return false;
                }
                this.searchParam3.page=1;
                res=await this.getTableData(filterParams(this.searchParam3));
                this.tableData3=res.data;
                this.total3=res.total;
            }else{
                if(this.searchParam4.id && !re.test(this.searchParam4.id)){
                    this.$msg("订单号输入内容格式不正确，请仔细核对");
                    return false;
                }
                this.searchParam4.page=1;
                res=await this.getTableData(filterParams(this.searchParam4));
                this.tableData4=res.data;
                this.total4=res.total;
            }
        },
        goPayOredr(row){
            let sourceType=this.$getlocalStorage("queryData")?.sourceType || this.$getlocalStorage("queryData")?.clientId || 975260;
            window.open(process.env.VUE_APP_VERIFY+`/payMethod?sid=${row.sid}&sourceType=${sourceType}`)       
        },
        async cancelOrder(row){
            let that=this;
            this.$confirm('确认取消该订单吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '关闭',
                type: 'warning'
            }).then(() => {
                orderCancel({orderId:row.id}).then(async (res)=>{
                    that.$msg("该订单已取消成功", "success");
                    that.searchParam2.page=1;
                    let table2=await that.getTableData(filterParams(this.searchParam2));
                    that.tableData2=table2.data;
                    that.total2=table2.total;
                }).catch(() => {
                    that.$msg("该订单取消失败，请稍后再试");
                });
            })
        },
        downloadReport(row){
            zhuge.track('用户中心_下载验证报告',{'渠道': this.channelCodeValue})
            downloadPdfReport({sid:row.sid}).then((res)=>{
                let link = document.createElement("a");
                link.style.display = "none";
                link.target = "_blank";
                link.href = res.pdfUrl;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }).catch((err) => {
                this.$msg(err.message);
            });
        },
        async handleClick(tab) {
            let res;
            if(tab.name=='first'){
                if(!(this.tableData1.length>0)){
                    res=await this.getTableData(filterParams(this.searchParam1));
                    this.tableData1=res.data;
                    this.total1=res.total;
                }
            }else if(tab.name=='second'){
                if(!(this.tableData2.length>0)){
                    res=await this.getTableData(filterParams(this.searchParam2));
                    this.tableData2=res.data;
                    this.total2=res.total;
                }
            }else if(tab.name=='third'){
                if(!(this.tableData3.length>0)){
                    res=await this.getTableData(filterParams(this.searchParam3));
                    this.tableData3=res.data;
                    this.total3=res.total;
                }
            }else{
                if(!(this.tableData4.length>0)){
                    res=await this.getTableData(filterParams(this.searchParam4));
                    this.tableData4=res.data;
                    this.total4=res.total;
                }
            }
        },
        async clickPage(page,num) {
            let res;
            if(num==1){
                this.searchParam1.page=page;
                res=await this.getTableData(filterParams(this.searchParam1));
                this.tableData1 =res.data;
                this.total1=res.total;
            }else if(num==2){
                this.searchParam2.page=page;
                res=await this.getTableData(filterParams(this.searchParam2));
                this.tableData2 =res.data;
                this.total2=res.total;
            }else if(num==3){
                this.searchParam3.page=page;
                res=await this.getTableData(filterParams(this.searchParam3));
                this.tableData3 =res.data;
                this.total3=res.total;
            }else{
                this.searchParam4.page=page;
                res=await this.getTableData(filterParams(this.searchParam4));
                this.tableData4 =res.data;
                this.total4=res.total;
            }
        },
        async clickSize(size,num) {
            let res;
            if(num==1){
                this.searchParam1.page=1;
                this.searchParam1.size=size;
                this.pageSizeNum1=size;
                res=await this.getTableData(filterParams(this.searchParam1));
                this.tableData1 =res.data;
                this.total1=res.total;
            }else if(num==2){
                this.searchParam2.page=1;
                this.searchParam2.size=size;
                this.pageSizeNum2=size;
                res=await this.getTableData(filterParams(this.searchParam2));
                this.tableData2 =res.data;
                this.total2=res.total;
            }else if(num==3){
                this.searchParam3.page=1;
                this.searchParam3.size=size;
                this.pageSizeNum3=size;
                res=await this.getTableData(filterParams(this.searchParam3));
                this.tableData3 =res.data;
                this.total3=res.total;
            }else{
                this.searchParam4.page=1;
                this.searchParam4.size=size;
                this.pageSizeNum4=size;
                res=await this.getTableData(filterParams(this.searchParam4));
                this.tableData4 =res.data;
                this.total4=res.total;
            }
        },
        datetime(e) {
            if(this.activeName=='first'){
                if(e){
                    this.searchParam1.startCreatedAt=e[0];
                    this.searchParam1.endCreatedAt=e[1];
                    console.log(this.searchParam1)
                }else{
                    this.searchParam1.startCreatedAt='';
                    this.searchParam1.endCreatedAt='';
                }

            }else if(this.activeName=='second'){
                if(e){
                    this.searchParam2.startCreatedAt=e[0];
                    this.searchParam2.endCreatedAt=e[1];
                    console.log(this.searchParam2)
                }else{
                    this.searchParam2.startCreatedAt='';
                    this.searchParam2.endCreatedAt='';
                }
            }else if(this.activeName=='third'){
                if(e){
                    this.searchParam3.startCreatedAt=e[0];
                    this.searchParam3.endCreatedAt=e[1];
                }else{
                    this.searchParam3.startCreatedAt='';
                    this.searchParam3.endCreatedAt='';
                }
            }else{
                if(e){
                    this.searchParam4.startCreatedAt=e[0];
                    this.searchParam4.endCreatedAt=e[1];
                }else{
                    this.searchParam4.startCreatedAt='';
                    this.searchParam4.endCreatedAt='';
                }
            }
        },
        payChange(payType){
            switch (payType) {
                case 1:
                    return 113;
                    break;
                case 2:
                    return 115;
                    break;
                case 3:
                    return 108;
                    break;
                case 4:
                    return 109;
                    break;
            }
        },
        async apply(row) {
            let that=this;
            if(row.invoiceStatus==2){
                this.$msg("该订单已开票");
                return false;
            }
            if(row.status==3){
                this.$msg("该订单已退款，不支持开票");
                return false;
            }
            let orderObj={
                orderList:[
                    {
                        'orderId': row.id,
                        'orderAmount': row.payAmount,
                        'chargeWay':that.payChange(row.payType),
                        'sourceType':975260,//row.sourceType,
                        'orderType':1,
                    }
                ]
            }
            sessionStorage.setItem("orderObj", JSON.stringify(orderObj));
            this.$router.push({
                path:'/invoice/personIn'
            })
        },
    },
};
</script>

<style lang="less" scoped>
.search{
    padding-top:20px;
}
.searchBar {
  padding: 20px 0px 10px;

  .el-button {
    margin-left: 13px;
  }
}

</style>
<style lang="less">
.exportDialog {
    .el-dialog__header{
        background: #EEEEEE;
    }
    .el-dialog__body{
        padding-bottom:0
    }
    p{
        box-sizing: border-box;
        width: 100%;
        padding:20px;
        background: #FFF9E1;
        color:#F17D44;
        border-radius: 10px;
    }
}
.exportForm{
    padding:20px;
    .yzm-item {
        .el-form-item__content{
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            .el-input{
                width:270px;
            }
            .getyzm{
                width: 120px;
                height: 28px;
                text-align: center;
                line-height: 28px;
                background: #fff;
                color: #3f7df7;
                cursor: pointer;
                border: 1px solid #3f7df7;
                font-size: 14px;
                &:hover{
                    background: #3f7df7;
                    color: #fff;
                }
            }
            .getyzm[disabled] {
                color: #fff;
                background: #bcbcbc;
                pointer-events: none;
                cursor: inherit;
                border-color: #bcbcbc;
            }
        }
        .el-form-item__content::after, .el-form-item__content::before{
            display: none;
        }
    }
}
</style>
